"use client";

// Root-felgräns — ersätter hela layouten om RootLayout självt kraschar.
// Renderar egen <html>/<body>. Loggar och erbjuder omladdning.

import { useEffect } from "react";
import { reportError } from "@/lib/error-report";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    reportError({
      kalla: "global-error",
      meddelande: error.message,
      stack: error.stack,
      digest: error.digest,
    });
  }, [error]);

  return (
    <html lang="sv">
      <body
        style={{
          fontFamily: "system-ui, sans-serif",
          padding: "3rem 1.5rem",
          maxWidth: "32rem",
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <h1 style={{ fontSize: "1.5rem", marginBottom: "0.75rem" }}>
          Något gick fel
        </h1>
        <p style={{ marginBottom: "1.5rem" }}>
          Sidan kunde inte visas. Ladda om för att försöka igen.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          title="Ladda om sidan"
          style={{
            padding: "0.6rem 1.4rem",
            borderRadius: "0.5rem",
            border: "1px solid #E63946",
            color: "#E63946",
            background: "transparent",
            cursor: "pointer",
          }}
        >
          Ladda om
        </button>
      </body>
    </html>
  );
}
